<template>
    <div class="component-wrap" data-app="true">
        <Header-menu />
        <div class="wrapper mb-4">
            <User-menu />
            <main class="layout column" :class="{'pt-0 pb-4': $vuetify.breakpoint.smAndDown, 'pa-4': $vuetify.breakpoint.mdAndUp}">
                <v-layout d-flex row wrap>
                    <StudyBlock />
                    <EventsBlock />
                </v-layout>
                <DatabaseBlock />
                <RatingBlock />
            </main>
        </div>
        <FooterBlock />
    </div>
</template>

<script>
// @ is an alias to /src
import HeaderMenu from '@/components/blocks/common/Header_menu.vue';
import UserMenu from '@/components/blocks/common/User_menu.vue';
import FooterBlock from '@/components/blocks/common/Footer.vue';
import StudyBlock from '@/components/view_blocks/Home/Home_study';
import EventsBlock from '@/components/view_blocks/Home/Home_events';
import DatabaseBlock from '@/components/view_blocks/Home/Home_database';
import RatingBlock from '@/components/view_blocks/Home/Home_rating';
import {mapGetters, mapActions} from 'vuex';

export default {
  name      : 'Home',
  components: {
    HeaderMenu,
    UserMenu,
    FooterBlock,
    StudyBlock,
    EventsBlock,
    DatabaseBlock,
    RatingBlock,
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters('Home', [
      'current_courses',
      'events',
      'feed',
      'idea',
    ]),
  },
  async mounted() {
    await this.get_main();
    this.replace_company();
  },
  methods: {
    ...mapActions('news_main', ['get_news']),
    ...mapActions('Home', ['get_main']),
    ...mapActions('Home', ['get_main']),
    ...mapActions('company_profile/info', [
      'replace_company',
    ]),
    async go_to_news() {
      await this.$router.push({name: 'news_main'});
    },
  },
};
</script>
<style lang="less" scoped>
.section-title {
  margin: 20px 0 10px 30px!important;
}
</style>
